export const FundOpportunityLabels: Readonly<Record<string, string>> = Object.freeze({
  name: 'Fund Name',
  summaryTitle: 'Summary Title',
  fundSize: 'Fund Size',
  fundDuration: 'Fund Duration',
  interest: 'Interest Rate',
  lga: 'LGA',
  returnOnInvestment: 'Return on Investment',
  siteArea: 'Site Area',
  currentValuation: 'Current Valuation',
  seniorDebtLvr: 'Senior Debt LVR',
  closeDate: 'Close Date',
  country: 'Country',
  state: 'State',
  sector: 'Sector',
  addresses: 'Addresses',
});
